import { render, staticRenderFns } from "./link-asset-drawer.vue?vue&type=template&id=bc699ba6&scoped=true&"
import script from "./link-asset-drawer.vue?vue&type=script&lang=js&"
export * from "./link-asset-drawer.vue?vue&type=script&lang=js&"
import style0 from "./link-asset-drawer.vue?vue&type=style&index=0&id=bc699ba6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc699ba6",
  null
  
)

export default component.exports